/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_SplitsInputs */

const en_ui_laps_splits = /** @type {(inputs: Ui_Laps_SplitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splits`)
};

const de_ui_laps_splits = /** @type {(inputs: Ui_Laps_SplitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splits`)
};

/**
* | output |
* | --- |
* | "Splits" |
*
* @param {Ui_Laps_SplitsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_splits = /** @type {((inputs?: Ui_Laps_SplitsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_SplitsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_splits(inputs)
	return de_ui_laps_splits(inputs)
});